export default function subscibeSchema(values) {
  const errors = {};
  if (!values.email) {
    errors.email = 'Email is required';
  }
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email';
  }

  return errors;
}
